export default "__VITE_ASSET__48c8e202__"